var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccd3eb;}.cls-2{fill:#f5f7ff;}.cls-3{fill:#0074ff;}.cls-4{fill:#647499;}.cls-5{fill:#96a1c3;}.cls-6{fill:#033c59;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Search, find") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_find",
    "data-name": "Search, find"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60,11V51a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55,11.9V44.29A5.88,5.88,0,0,1,49,50H3V12H5v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60,6v8H4V6A2,2,0,0,1,6,4H58A2,2,0,0,1,60,6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 42,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 48,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 54,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,32A12,12,0,0,1,30,43.83a11.76,11.76,0,0,1-3.28-1,11.93,11.93,0,0,1-1.39-.8,12.1,12.1,0,0,1-2.25-2,12,12,0,0,1,8-20c.32,0,.64,0,1,0a11.45,11.45,0,0,1,2.28.22c.34.06.67.14,1,.23A12,12,0,0,1,44,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38,30A12,12,0,0,1,26,42l-.67,0a12.1,12.1,0,0,1-2.25-2,12,12,0,0,1,8-20c.42,0,.83.1,1.24.18s.67.14,1,.23A12,12,0,0,1,38,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34,43.83V48H30V43.83a11.85,11.85,0,0,0,4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35,49v8a3,3,0,0,1-5.82.88A3.09,3.09,0,0,1,29,56.83V49a1,1,0,0,1,1-1h4A1,1,0,0,1,35,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M33,48v7a3,3,0,0,1-3.22,3,2.36,2.36,0,0,1-.6-.11A3.09,3.09,0,0,1,29,56.83V49a1,1,0,0,1,1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9,10H28a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M16,5h1a1,1,0,0,0,0-2H16a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58,3H21a1,1,0,0,0,0,2H58a1,1,0,0,1,1,1v7H5V6A1,1,0,0,1,6,5h6a1,1,0,0,0,0-2H6A3,3,0,0,0,3,6V51a3,3,0,0,0,3,3H28v3a4,4,0,0,0,8,0V54H58a3,3,0,0,0,3-3V6A3,3,0,0,0,58,3ZM33.83,42.84A10.29,10.29,0,0,1,32,43c-.31,0-.61,0-.92,0s-.61-.06-.91-.12h0a11,11,0,1,1,3.66,0ZM31,45l.78,0h.44L33,45v2H31Zm3,12a2,2,0,0,1-4,0V49h4Zm24-5H36V48a1,1,0,0,0-1-1V44.64a13,13,0,1,0-6,0V47a1,1,0,0,0-1,1v4H6a1,1,0,0,1-1-1V15H59V51A1,1,0,0,1,58,52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 42,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 48,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 54,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8,9a1,1,0,0,0,1,1H28a1,1,0,0,0,0-2H9A1,1,0,0,0,8,9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG1);
export default __webpack_public_path__ + "static/media/G1.b5a3719bbb2f6f52bb7aeb79085e9e3b.svg";
export { ForwardRef as ReactComponent };